// extracted by mini-css-extract-plugin
export default {"cls1":"VeloGrid-Cell_cls1__NIO6V","cls2":"VeloGrid-Cell_cls2__KIsHi VeloGrid-Cell_cls1__NIO6V","mobileAlign-right":"VeloGrid-Cell_mobileAlign-right__ovZ1O"};